// Map workspace names to ROMM ID prefixes
export const WORKSPACE_PREFIX: Record<string, string> = {
  "Employee Benefits Expense": "EBE",
  "Property, Plant & Equipment": "PPE",
  "Intangible Assets": "IT",
  "Intangible Assets Under Development": "IAUD",
  "Impairment Testing": "IMPR",
  "Depreciation": "DEPR",
  "Revenue from Operations": "RFO",
  "Evaluate Audit Results Including Misstatements": "EARM",
  "Financial Closing & Reporting Process": "FCRP",
  "Other Assets": "OTAS",
  "Other Financial Assets": "OFA",
  "Other Financial Liabilities": "OFL",
  "Lease Liability": "LEASE",
  "Lease Liability - Ind AS": "LEASE",
  "Right-of-Use Assets": "ROU",
};

/**
 * Get the prefix for a workspace name
 * @param workspace - The workspace name
 * @returns The prefix string (e.g., "EBE" for "Employee Benefits Expense")
 */
export function toPrefix(workspace: string): string {
  if (WORKSPACE_PREFIX[workspace]) return WORKSPACE_PREFIX[workspace];
  const words = workspace.replace(/[^A-Za-z\s]/g, "").trim().split(/\s+/);
  const derived = words.map(w => (w[0] || "").toUpperCase()).join("").slice(0, 4);
  return derived || "ROMM";
}

